export const unitMap = {
  metric: 'sq m',
  imperial: 'sq ft',
  'metric-large': 'ha',
  'imperial-large': 'ac',
  percent: '%',
  percentgdv: '%',
  percentcost: '%',
  fixed: '£',
}

export const unitOptions = {
  'metric-imperial': [
    {
      value: 'metric',
      label: 'Metric (sq m)',
    },
    {
      value: 'imperial',
      label: 'Imperial (sq ft)',
    },
  ],
  'percent-fixed': [
    {
      value: 'percent',
      label: '%',
    },
    {
      value: 'fixed',
      label: '£',
    },
  ],
  'percentgdv-percentcost-fixed': [
    {
      value: 'percentgdv',
      label: '% of GDV',
    },
    {
      value: 'percentcost',
      label: '% of cost',
    },
    {
      value: 'fixed',
      label: '£',
    },
  ],
}
